import { useEffect, useState, useCallback } from 'react';

/**
 * Mantiene la barra de composición (input + enviar) pegada al borde visible en móvil
 * cuando aparece el teclado virtual (visualViewport).
 */
export function useVisualViewportComposer(enabled = true) {
  const [composerRef, setComposerRef] = useState(null);
  const [composerHeight, setComposerHeight] = useState(0);
  const [composerStyle, setComposerStyle] = useState({});

  const setRef = useCallback((node) => {
    setComposerRef(node);
  }, []);

  useEffect(() => {
    if (!enabled || !composerRef) return undefined;

    const measure = () => {
      const h = composerRef.offsetHeight || 0;
      setComposerHeight(h);
    };

    const updatePosition = () => {
      const vv = window.visualViewport;
      if (!vv) {
        setComposerStyle({
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 50,
        });
        measure();
        return;
      }

      const inset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      setComposerStyle({
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: inset,
        zIndex: 50,
      });
      measure();
    };

    updatePosition();

    const vv = window.visualViewport;
    vv?.addEventListener('resize', updatePosition);
    vv?.addEventListener('scroll', updatePosition);
    window.addEventListener('resize', updatePosition);

    const ro =
      typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;
    ro?.observe(composerRef);
    measure();

    return () => {
      vv?.removeEventListener('resize', updatePosition);
      vv?.removeEventListener('scroll', updatePosition);
      window.removeEventListener('resize', updatePosition);
      ro?.disconnect();
    };
  }, [enabled, composerRef]);

  return { composerRef: setRef, composerStyle, composerHeight };
}
